import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useParams,useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

const Container = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-radius: 10px;
`;

const Title = styled.h2`
  text-align: left;
  color: #333;
  margin-bottom: 20px;
`;

const BidForm = styled.form`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

const Label = styled.label`
  margin-bottom: 8px;
  font-weight: bold;
`;

const Input = styled.input`
  padding: 8px;
  margin-bottom: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const Button = styled.button`
  padding: 10px 20px;
  color: white;
  background-color: #007BFF;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

const BidList = styled.div`
  margin-top: 20px;
  background-color: #fff;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const BidItem = styled.div`
  padding: 10px;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
`;
const Td = styled.td`
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: white;
  overflow: hidden;
`;
const TimerDisplay = styled.div`
  font-size: 72px;
  font-weight: bold;
  color: ${(props) => (props.isCritical ? 'red' : '#32CD32')};
  background-color: #000;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  font-family: 'Digital-7 Mono', monospace;
  letter-spacing: 2px;
  margin-bottom: 20px;
`;
const Th = styled.th`
  background-color: #3498db;
  color: white;
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
  
`;
const TimerTd = styled(Td)`
  color: ${(props) => (props.isCritical ? 'red' : 'black')};
`;

const PublicOrderBids = () => {
  const navigate = useNavigate();
  const { menuId } = useParams(); // URL에서 menuId를 가져옵니다.
  const [bidAmount, setBidAmount] = useState('');
  const [bidders, setBidders] = useState([]);
  const [message, setMessage] = useState('');
  const [user,setUser] = useState({});
  const [order, setOrder] = useState([]);
  
    const fetchPublicOrder = async () => {
    try {
      //console.log("Fetching public order with menuId:", menuId);  // menuId 확인용 로그
      const response = await fetch(`/Acution/public-order-item/${menuId}`, {
        credentials: 'include',
      });
      const data = await response.json();
      setOrder(data);
    } catch (error) {
      console.error('Error fetching public orders:', error);
    }
  };
  useEffect(() => {
    fetchPublicOrder();
    const intervalId = setInterval(() => {
      setOrder((prevOrder) => {
        const remainingTime = calculateRemainingTime(prevOrder.end_time);
        console.log(prevOrder.end_time);
        return { ...prevOrder, remainingTime };
      });
    }, 1000);


    return () => clearInterval(intervalId);
  }, []);

  const calculateRemainingTime = (endTime) => {
    const end = new Date(endTime);
    const now = new Date();
    const diff = end - now;

    if (diff <= 0) {
      navigate('/Tiketting/PublicOrderList');
      return 'Expired';
    }

    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  useEffect(() => {
    const storedUser = sessionStorage.getItem('session_user');
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      //console.log("Fetched user from session on init:", parsedUser); // 데이터 확인 로그
      setUser(parsedUser);
    }
    fetchBidders();
  }, []);

  const fetchBidders = async () => {
    try {
      const response = await fetch(`/Acution/public-order/${menuId}/bidders`, {
        credentials: 'include',
      });
      const data = await response.json();
      setBidders(data);
    } catch (error) {
      console.error('Error fetching bidders:', error);
    }
  };

  const handleBidSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitting bid for menuId:", menuId); // menuId 값 확인
    try {
      const response = await fetch('/Acution/place-bid', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          public_order_id: menuId, // menuId를 public_order_id로 사용
          bid_amount: bidAmount,
        }),
      });
  
      if (response.ok) {
        setMessage('입찰이 성공적으로 완료되었습니다!');
        fetchBidders();
      } else {
        const errorData = await response.json();
        if (errorData.error === '이미 이 주문에 입찰했습니다.') {
          setMessage('입찰 내역이 있습니다.');
        } else if (errorData.error === '입찰이 제한된 사용자입니다.') {
          setMessage('입찰이 제한된 사용자입니다.');
        } else {
          setMessage(errorData.error || '입찰에 실패하였습니다.');
        }
      }
    } catch (error) {
      console.error('입찰 중 오류 발생:', error);
      setMessage('입찰 중 오류가 발생했습니다.');
    }
  };

  return (
    <Container>
      <Title>공개 경매 입찰하기</Title>
      <TimerDisplay
        isCritical={
          order.remainingTime &&
          order.remainingTime.split(':')[0] === '0' &&
          parseInt(order.remainingTime.split(':')[1]) <= 59
        }
      >
        {order.remainingTime || calculateRemainingTime(order.end_time)}
      </TimerDisplay>
      <BidForm onSubmit={handleBidSubmit}>
        <Label>입찰 금액:</Label>
        <Input
          type="number"
          value={bidAmount}
          onChange={(e) => setBidAmount(e.target.value)}
          required
        />
        <Button type="submit">입찰</Button>
      </BidForm>
      {message && <p>{message}</p>}
        {/* {JSON.stringify(user&& user.id)} */}
      <BidList>
      {/* <TimerTd isCritical={order.remainingTime && order.remainingTime.split(':')[0] === '0' && parseInt(order.remainingTime.split(':')[1]) <= 59}>
                {order.remainingTime || calculateRemainingTime(order.end_time)}
        </TimerTd> */}
  
        <span>{bidders.length}명이 입찰 참여중</span>
          <hr/>
        <label>내 입찰정보</label>
        {bidders
          .filter((bidder) => bidder.agent_id === user?.id) // 사용자 본인의 입찰만 필터링
          .map((bidder, index) => (
            <BidItem key={index}>
              <span>{bidder.agent_id}</span>
              <span>{bidder.bid_amount}</span>
              <span>{new Date(bidder.timestamp).toLocaleString()}</span>
            </BidItem>
          ))}
      </BidList>
    </Container>
  );
};

export default PublicOrderBids;
